import { SVGProps } from "react";

const RightArrowWhiteIcon = ({
  className,
  stroke = "#FFFFFF",
  ...props
}: SVGProps<SVGSVGElement> & { className?: string; stroke?: string }) => (
  <svg
    width="12"
    height="11"
    viewBox="0 0 12 11"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    aria-hidden={true}
    {...props}
  >
    <path
      d="M1.00195 5.50065H11.002M11.002 5.50065L6.33529 10.1673M11.002 5.50065L6.33529 0.833984"
      stroke={stroke}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default RightArrowWhiteIcon;
